import React, { useEffect, useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const DownloadQr = ({ onClose, product }) => {
    const [batchId, setBatchId] = useState("");
    const [columns, setColumns] = useState(2);
    const [repeats, setRepeats] = useState(1);
    const [loading, setLoading] = useState(false);
    const batches = product?.batches

    const handleDownload = async (batchId) => {
        if (loading) return;
        if (!batchId) {
            alert('Please enter batch ID');
            return;
        }
        const token = localStorage.getItem('token')
        const url = import.meta.env.VITE_APP_ADMINURL + `/api/download-batch-excel?batchId=${batchId}&columns=${columns}&repeats=${repeats}`;
        try {
            setLoading(true);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) {
                throw new Error('failed to Download file')
            }
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'batch_export.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error(error);
            alert('Error Dowloading file')
        } finally {
            setLoading(false);
        }
    };

    if (!batches || batches.length === 0) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-gray-200">
                        <h2 className="text-xl font-semibold text-text-primary">Download QR Codes Excel</h2>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <Icon name="X" size={20} color="#6b7280" />
                        </button>
                    </div>
                    <div className="p-12 text-center">
                        There is no batch to download
                    </div>
                </div>
            </div>
        )

    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-text-primary">Download QR Codes Excel</h2>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        <Icon name="X" size={20} color="#6b7280" />
                    </button>
                </div>
                <div className="p-4 max-w-md mx-auto bg-white rounded shadow">
                    <div className="mb-3">
                        <label>Batch ID</label>
                        <select
                            value={batchId}
                            onChange={(e) => setBatchId(e.target.value)}
                            className="border p-2 w-full rounded"
                        >
                            <option value="" disabled>Select</option>
                            {batches.map((batch) => (
                                <option key={batch.id} value={batch.id}>
                                    {batch.title} ({batch.batch_code})
                                </option>
                            ))}
                        </select>

                    </div>
                    <div className="mb-3">
                        <label>Columns per row</label>
                        <input
                            type="number"
                            min="1"
                            value={columns}
                            onChange={(e) => setColumns(Number(e.target.value))}
                            className="border p-2 w-full rounded"
                        />
                    </div>
                    <div className="mb-3">
                        <label>Repeat times</label>
                        <input
                            type="number"
                            min="1"
                            value={repeats}
                            onChange={(e) => setRepeats(Number(e.target.value))}
                            className="border p-2 w-full rounded"
                        />
                    </div>
                    <Button
                        onClick={() => handleDownload(batchId)}
                        className="text-white"
                        loading={loading}
                    >
                        Download Excel
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DownloadQr;
